import { render, staticRenderFns } from "./ed-login-popup.vue?vue&type=template&id=fc0f1b5c&scoped=true&"
import script from "./ed-login-popup.ts?vue&type=script&lang=ts&"
export * from "./ed-login-popup.ts?vue&type=script&lang=ts&"
import style0 from "./ed-login-popup.scss?vue&type=style&index=0&id=fc0f1b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0f1b5c",
  null
  
)

export default component.exports